const FiltersBase = {
  'Sort by'() {
    return {
      name: 'Sort by',
      values: [
        {
          name: 'Relevance',
          enabled: true,
        },
        {
          name: 'Price',
          enabled: false,
        },
        {
          name: 'Calories',
          enabled: false,
        },
      ],
      type: 'sort',
    };
  },
  Diet() {
    return {
      name: 'Diet',
      values: [
        {
          slug: 'Gluten free',
          name: 'No Gluten Containing (NGC)',
          enabled: false,
        },
        {
          slug: 'Vegan',
          name: 'Vegan (VG)',
          enabled: false,
        },
        {
          slug: 'Vegetarian',
          name: 'Vegetarian (V)',
          enabled: false,
        },
      ],
      type: 'filters',
    };
  },
  Calories(caloryValues) {
    return {
      name: 'Calories',
      values: [
        {
          name: `Below ${caloryValues.min} kcal`,
          enabled: false,
          min: 0,
          max: caloryValues.min - 1,
        },
        {
          name: `Between ${caloryValues.min}-${caloryValues.max} kcal`,
          enabled: false,
          min: caloryValues.min,
          max: caloryValues.max,
        },
        {
          name: `Above ${caloryValues.max} kcal`,
          enabled: false,
          min: caloryValues.max + 1,
          max: Infinity,
        },
      ],
      type: 'filters',
    };
  },
  Others() {
    return {
      name: 'Others',
      values: [
        {
          name: 'Show calories',
          enabled: true,
        },
      ],
      type: 'switch',
    };
  },
};

const getFilters = (filters, caloryValues) => {
  const arr = [];
  filters.forEach((filter) => {
    if (FiltersBase[filter]) arr.push(FiltersBase[filter](caloryValues));
    else console.warn(`No ${filter} on FiltersBase!`);
  });

  return arr;
};

export default getFilters;
